// src/pages/PostDetail.tsx
import { useParams, Link } from "react-router-dom";
import { INSIGHT_POSTS } from "../data/posts";

const PostDetail = () => {
  const { id } = useParams<{ id: string }>();
  const post = INSIGHT_POSTS.find((p) => p.id === id || p.slug === id);

  if (!post) {
    return (
      <div className="bg-bg">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-20">
          <p className="text-sm text-muted mb-4">
            This insight could not be found.
          </p>
          <Link to="/insights" className="text-sm font-semibold text-signal hover:underline">
            ← Back to insights
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-bg">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <p className="font-mono text-xs text-muted tracking-wide mb-3">
          INSIGHTS ·{" "}
          {new Date(post.date)
            .toLocaleDateString("en-GB", {
              year: "numeric",
              month: "short",
              day: "2-digit",
            })
            .toUpperCase()}{" "}
          · {post.readingTime.toUpperCase()}
        </p>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold text-ink mb-4">
          {post.title}
        </h1>
        <div className="flex flex-wrap gap-2 mb-8">
          {post.tags.map((tag) => (
            <span key={tag} className="tag-chip">
              {tag}
            </span>
          ))}
        </div>
        <article className="space-y-4 text-sm sm:text-base leading-relaxed text-ink">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </article>
        <div className="mt-10 pt-6 border-t border-line">
          <Link to="/insights" className="text-sm font-semibold text-signal hover:underline">
            ← Back to insights
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PostDetail;
